import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { WhiteBoardStampIcon } from '@sketchnote/icons';
import { Button, Panel as Panel2, Tabs } from '@sketchnote/shared-components';
import * as React from 'react';
import { Panel, TDShapeType, ToolButton, Tooltip, useTldrawApp } from 'sn-wb-tldraw';

const stickerShapes: string[] = [
  'flame',
  'thumbsUp',
  'thumbsDown',
  'heart',
  'sparkles',
  'question',
  'starStruck',
  'pensiveFace',
  'explodingHead',
  'faceWithMonocle',
  'skull',
];

const faceShapes: string[] = [
  'personBlue',
  'personPink',
  'personBlack',
  'personGreen',
  'personGray',
];

const stickerIcons = {
  flame: 'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-flame.png',
  thumbsUp:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-thumbsup.png',
  thumbsDown:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-thumbsdown.png',
  heart: 'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-heart.png',
  sparkles:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-sparkles.png',
  question:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-question.png',
  starStruck:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-starstruck.png',
  pensiveFace:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-pensiveface.png',
  explodingHead:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-explodinghead.png',
  faceWithMonocle:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-face-with-monocle.png',
  skull: 'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/emoji-skull.png',
};

const faceIcons = {
  personBlue:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/person-blue.png',
  personPink:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/person-pink.png',
  personBlack:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/person-black.png',
  personGreen:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/person-green.png',
  personGray:
    'https://res.cloudinary.com/samvibes/image/upload/whiteboard-stickers/person-gray.png',
};

export const StampMenu = React.memo(function StampMenu(): JSX.Element {
  const app = useTldrawApp();

  const isSmallScreen = window.innerHeight < 800;

  const sideOffset = isSmallScreen ? 26 : 37;

  const selectSticker = (shape) => {
    app.selectSticker(shape);
    app.selectTool(TDShapeType.Sticker);
  };

  const selectStickerTool = () => {
    app.selectSticker('');
    app.selectTool('select');
  };

  return (
    <Menu direction="ltr" isLazy offset={[-110, sideOffset]} placement="right">
      <div className="h-48 w-48  smallScreen:h-32 smallScreen:w-32 flex justify-center items-center">
        <Tooltip id="Stickers" label="Stickers" side="right">
          <MenuButton
            onClick={selectStickerTool}
            className="bg-gray-100 rounded-sm h-48 w-48 smallScreen:h-32 smallScreen:w-32 flex items-center justify-center "
          >
            <WhiteBoardStampIcon fill={'#55585E'} wrapperClass="transform smallScreen:scale-50" />
          </MenuButton>
        </Tooltip>
      </div>

      <MenuList>
        <Panel
          className="w-57 smallScreen:w-37"
          style={{
            boxShadow: '0px 4px 4px rgba(135, 138, 146, 0.15)',
            borderRadius: '10px',
            border: '1px solid #E2E4E9',
          }}
          side="center"
        >
          <div className="flex flex-col items-center gap-4">
            {stickerShapes.map((shape) => (
              <div
                key={shape}
                className="h-38 w-44 smallScreen:h-25 smallScreen:w-29 flex  justify-center items-center  hover:bg-gray-199"
              >
                <Tooltip
                  label={shape}
                  side="right"
                  // kbd={(4 + i).toString()}
                  id={`TD-PrimaryTools-Shapes-${shape}`}
                >
                  <MenuItem asChild>
                    <div className="transform scale-1 smallScreen:scale-75">
                      <ToolButton
                        variant="primary"
                        onClick={selectSticker.bind(null, stickerIcons[shape])}
                      >
                        {<img src={stickerIcons[shape]} />}
                      </ToolButton>
                    </div>
                  </MenuItem>
                </Tooltip>
              </div>
            ))}
            <div
              className="w-28 mt-7 mb-5 mx-auto"
              style={{ borderBottom: '1px dashed #E2E4E9' }}
            ></div>
            {faceShapes.map((shape) => (
              <div
                key={shape}
                className="h-38 w-44 smallScreen:h-25 smallScreen:w-29 flex  justify-center items-center  gap-3 hover:bg-gray-199"
              >
                <Tooltip
                  label={shape[0].toUpperCase() + shape.slice(1)}
                  side="right"
                  // kbd={(4 + i).toString()}
                  id={`TD-PrimaryTools-Shapes-${shape}`}
                >
                  <MenuItem asChild>
                    <div className="transform scale-120 smallScreen:scale-90">
                      <ToolButton
                        variant="primary"
                        onClick={selectSticker.bind(null, faceIcons[shape])}
                      >
                        {<img src={faceIcons[shape]} />}
                      </ToolButton>
                    </div>
                  </MenuItem>
                </Tooltip>
              </div>
            ))}
          </div>
        </Panel>
      </MenuList>
    </Menu>
  );
});
